module.exports = __webpack_public_path__ + "985b6505b8fd329096ab9d5dafa7c863.svg";